import { components, constants, useServices} from 'cng-web-lib'
import SublocationApiUrls from 'src/apiUrls/SublocationApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router-dom'

const {
  form: { CngEditForm }
} = components

const {
  filter: { EQUAL }
} = constants

function EditPage({ showNotification }) {
  const { id } = useParams()
  const { fetchRecords } = useServices()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngEditForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap, shouldDisableMap) => (
            <FormProperties.Fields
              disabled={true}
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            onSendRequest: (onSuccess, onError, onComplete) => {
              fetchRecords.execute(
                SublocationApiUrls.GET,
                {
                  filters: [{ field: 'id', operator: EQUAL, value: id }],
                  customData: { codeMType: 'Sublocation' }
                },
                onSuccess,
                onError,
                onComplete
              )
            }
          }}
          update={{
            url: SublocationApiUrls.PUT
          }}
          id={id}
        />
      </Grid>
    </Grid>
  )
}

export default EditPage
